<template>
  <div>
    <div style="padding: 10px 20px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #eee">
      <div style="font-size: 16px;font-weight: bold">{{ state === '编辑' ? $t('station.editTitle') : $t('station.addTitle') }}</div>
      <a-space>
        <a-button type="primary" @click="save">{{ $t('buttons.save') }}</a-button>
        <a-button @click="$router.back()">{{ $t('buttons.goBack') }}</a-button>
      </a-space>
    </div>
    <div style="padding: 10px;border-bottom:  1px solid #eee">
      <a-form-model ref="ruleForm" :model="stationForm" :rules="rules" layout="inline" v-bind="{ labelCol: { span: 10 },wrapperCol: { span: 14 } }" >
        <a-form-model-item :label="$t('station.code')" prop="code">
          <a-input v-model="stationForm.code" :disabled="state === '编辑'" />
        </a-form-model-item>
        <a-form-model-item :label="$t('station.name')" prop="name">
          <a-input v-model="stationForm.name" />
        </a-form-model-item>
        <a-form-model-item :label="$t('common.customer')" style="width: 300px; position: relative" prop="customerId">
          <a-input v-model="stationForm.company" @keyup.enter="handleSearchCustomer" @blur="searchingCustomer=false" />
          <ul v-show="searchingCustomer" class="customer">
            <a-spin style="position: absolute; left: 50%; transform: translate(-50%)" v-show="cLoading" />
            <li @mousedown="selectCustomer(c)" :title="c.company" v-for="c in customerList" :key="c.id">
              {{ c.company }}
            </li>
          </ul>
        </a-form-model-item>
        <a-form-model-item :label="$t('common.pressure')" style="width: 400px;">
          <a-input v-model="pressure" @focus="pressureShow = true" style="width: 100%"/>
          <div class="dataMenu" v-show="pressureShow" style="position: absolute; width: 100%; z-index: 1000; background-color: #fff;">
            <table style="width: 100%; text-align: center">
              <thead>
                <tr style="text-align: left">
                  <th>
                    <a href="javascript:;" style="font-size: 16px; font-weight: 400; margin-right: 10px" @click="addItem('pressure')">{{ $t('customer.add') }}</a>
                    <a href="javascript:;" :disabled="pressureTableList.length === 0" style="font-size: 16px; font-weight: 400; margin-right: 10px" @click="removeTableItem('pressure')">{{ $t('warningForm.undo') }}</a>
                  </th>
                </tr>
                <tr>
                  <th>{{ $t('configuration.device') }}</th>
                  <th>{{ $t('configuration.parameter') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(pressure, index) in pressureTableList">
                  <!-- <Tr :groupDrawer="groupDrawer" v-if="groupDrawer.visible" :key="index" :dataType="'pressure'" :setData="setData" :index="index"></Tr> -->
                  <tr :key="pressure.deviceCode" @click.stop>
                    <td style="width: 50%" @click.stop>
                      <a-select style="width: 100%" :getPopupContainer="triggerNode => triggerNode.parentNode" v-model="pressure.deviceCode">
                        <a-select-option v-for="device in deviceList" :key="device.id" :value="device.code" @click="getDataByDevice(device, index, 'pressure')">
                          {{ device.name }}
                        </a-select-option>
                      </a-select>
                    </td>
                    <td style="width: 50%">
                      <a-select style="width: 100%" :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="pressure.data">
                        <a-select-option v-for="menuData in pressure.dataList" :key="menuData.code" :value="menuData.code">
                          {{menuData.name}}
                        </a-select-option>
                      </a-select>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <a-button type="primary" size="small" style="position: relative; left: 65%" @click="setStr('pressure')">{{ $t('common.okText') }}</a-button>
          </div>
        </a-form-model-item>
        <!-- <a-form-model-item :label="$t('station.flow')" style="width: 400px; margin-left: -70px">
          <a-input v-model="flow" @focus="flowShow = true" style="width: 120%"/>
          <div class="dataMenu" v-show="flowShow" style="position: absolute; width: 100%; z-index: 1000; background-color: #fff;">
            <table style="width: 100%; text-align: center">
              <thead>
                <tr style="text-align: left">
                  <th>
                    <a href="javascript:;" style="font-size: 16px; font-weight: 400; margin-right: 10px" @click="addItem('flow')">{{ $t('customer.add') }}</a>
                    <a href="javascript:;" :disabled="flowTableList.length === 0" style="font-size: 16px; font-weight: 400; margin-right: 10px" @click="removeTableItem('flow')">{{ $t('warningForm.undo') }}</a>
                  </th>
                </tr>
                <tr>
                  <th>{{ $t('configuration.device') }}</th>
                  <th>{{ $t('configuration.parameter') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="(flow, index) in flowTableList">
                  <tr :key="flow.deviceCode" @click.stop>
                    <td style="width: 50%" @click.stop>
                      <a-select style="width: 100%" :getPopupContainer="triggerNode => triggerNode.parentNode" v-model="flow.deviceCode">
                        <a-select-option v-for="device in deviceList" :key="device.id" :value="device.code" @click="getDataByDevice(device, index, 'flow')">
                          {{ device.name }}
                        </a-select-option>
                      </a-select>
                    </td>
                    <td style="width: 50%">
                      <a-select style="width: 100%" :getPopupContainer="(triggerNode) => triggerNode.parentNode" v-model="flow.data">
                        <a-select-option v-for="menuData in flow.dataList" :key="menuData.code" :value="menuData.code">
                          {{menuData.name}}
                        </a-select-option>
                      </a-select>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
            <a-button type="primary" size="small" style="position: relative; left: 65%" @click="setStr('flow')">{{ $t('common.okText') }}</a-button>
          </div>
        </a-form-model-item> -->
        <a-form-model-item :label="$t('station.gasElectricRatio')" prop="gasElectricRatio" v-bind="{ labelCol: { span: 10 }, wrapperCol: { span: 14 } }">
          <a-input style="margin-left: 4px" v-model="stationForm.gasElectricRatio" />
        </a-form-model-item>
        <a-form-model-item :label="$t('station.interval')" prop="interval">
          <a-input v-model="stationForm.interval" />
        </a-form-model-item>
        <a-form-model-item :label="$t('common.remark')">
          <a-input v-model="stationForm.remark" />
        </a-form-model-item>
        <a-form-model-item :label="$t('warningForm.template')">
          <a-checkbox-group v-model="extraProperty.model" style="width: 175px;">
            <a-checkbox value="1">
              {{ $t('station.configuration') }}
            </a-checkbox>
            <a-checkbox value="2">
              {{ $t('station.data') }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item :label="$t('station.charts')">
          <a-checkbox-group v-model="extraProperty.charts" style="width: 175px;">
            <a-checkbox value="1">
              {{ $t('device.preview') }}
            </a-checkbox>
            <a-checkbox value="2">
              {{ $t('buttons.fullscreen') }}
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item :label="$t('station.gasUnit')" style="width: 200px">
          <a-select :value="extraProperty.unit" @change="handleUnitChange">
            <a-select-option value='Nm³'>Nm³</a-select-option>
            <a-select-option value='m³'>m³</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item :label="$t('station.showElec')" style="width: 180px">
          <a-checkbox :checked="stationForm.elecVisible" @change="handleElecVisibleChange" />
        </a-form-model-item>
        <br />
        <a-form-model-item :label="$t('station.deviceSelect')" style="width: 100%;" v-bind="{ labelCol: { span: 1, wrapperCol: 21 } }">
          <a-select mode="tags" style="min-width: 141%;" :placeholder="$t('messages.selectDevice')" v-model="selectedDevices">
            <a-select-option v-for="device in deviceList" :key="device.code">
              {{device.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <!-- <a-form-model-item :label="$t('station.selectStation')" style="width: 100%;" v-bind="{ labelCol: { span: 1, wrapperCol: 21 } }">
          <a-select mode="tags" style="min-width: 141%;" :placeholder="$t('station.ss')" v-model="selectedStations">
            <a-select-option v-for="device in stations" :key="device.id + ''">
              {{device.name}}
            </a-select-option>
          </a-select>
        </a-form-model-item> -->
      </a-form-model>
    </div>
    <div style="padding: 10px;display: flex;align-items: center;justify-content: space-between">
      <div style="font-weight: bold;font-size: 16px;">{{ $t('device.title') }}</div>
      <div>
        <a-button type="primary" @click="deviceModalVisible = true" :disabled="!stationForm.customerId">{{ $t('customer.addDevice') }}</a-button>
      </div>
    </div>
    <a-table :columns="deviceColumns" :rowKey="record => record.id" :data-source="deviceList">
      <template v-slot:updatedAt="text, record">
        {{ moment(record.updatedAt).format('YYYY-MM-DD HH:mm:ss') }}
      </template>
      <template v-slot:createdAt="text, record">
        {{ moment(record.createdAt).format('YYYY-MM-DD HH:mm:ss') }}
      </template>
      <template v-slot:operation="text, record">
        <a-button @click="removeDevice(record)" type="link" size="small" style="padding-left: 0">{{ $t('buttons.delete') }}</a-button>
      </template>
    </a-table>
    <device-modal :visible="deviceModalVisible" :customer-id="stationForm.customerId" @close="closeModal" :deviceList="deviceList" :total="total" />
  </div>
</template>

<script>
import { updateDeviceGroup, generateDeviceGroupCode } from '@/api/device'
import { getDeviceGroupList, addDeviceGroup, getDeviceGroup } from '@/api/device'
import { getProtocol } from '@/api/protocol'
import moment from 'moment'
import deviceGroupApi from '@/api/device-group'
import DeviceModal from '@/views/EquipmentManager/EquipmentGroup/components/DeviceModal'
import Tr from '../components/Tr'
import { searchCustomerList } from '@/api/customer'

const queryParams = {
  query: [],
  filter: [
    {
      field: 'customerId',
      value: ''
    }
  ],
  sort: [
    {
      field: 'updatedAt',
      value: 'DESC'
    }
  ]
}

export default {
  name: 'index',
  components: { DeviceModal, Tr },
  mounted () {
    this.deviceColumns.forEach(item => {
      if (this.queryFields.indexOf(item.dataIndex) !== -1) {
        item.scopedSlots = {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      }
    })
    getDeviceGroupList(1, 50).then(async res => {
      if (res.data.total > 50) {
        const { data } = await getDeviceGroupList(1, res.data.total)
        this.stations = data.records
      } else {
        this.stations = res.data.records
      }
    })
    if (this.$store.state.stationInfo) {
      this.state = '编辑'
      queryParams.filter[0].value = this.$store.state.stationInfo.customerId
      // searchDeviceList(1, 50, queryParams).then(async res => {
      //   if (res.data.total <= 50) {
      //     this.deviceList = res.data.records
      //     this.groupDrawer.deviceList = res.data.records
      //   } else {
      //     const { data } = await searchDeviceList(1, res.data.total)
      //     this.groupDrawer.deviceList = data.records
      //     this.deviceList = data.records
      //   }
      //   console.log(this.deviceList);
      //   const { data } = await getCustomerById(this.$store.state.stationInfo.customerId)
      //   this.customerList.push(data)

      //   this.deviceList.forEach(item => {
      //     item.createdAt = moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
      //     item.updatedAt = moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss')
      //   })
      this.getDevices()
      // })
    } else {
      this.state = "新增"
      generateDeviceGroupCode().then(({ data }) => {
        this.stationForm.code = data
      }).catch(e => console.log(e))
    }
    this.globalClick(this.hideSelectOption)
  },
  data () {
    return {
      deviceColumns: [
        {
          title: () => this.$t('common.deviceCode'),
          dataIndex: 'code',
          key: 'code',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => record.code.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              console.log(this)
              this.$nextTick(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: () => this.$t('common.deviceName'),
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => record.name.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              this.$nextTick(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: () => this.$t('customer.company'),
          dataIndex: 'company',
          key: 'company'
        },
        {
          title: () => this.$t('common.model'),
          dataIndex: 'model',
          key: 'model',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => record.model.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              this.$nextTick(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: () => this.$t('common.brand'),
          dataIndex: 'brand',
          key: 'brand',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender'
          },
          onFilter: (value, record) => record.brand.toString().toLowerCase().includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              // setTimeout(() => {
              //   this.searchInput.focus()
              // }, 0)
              this.$nextTick(() => {
                this.searchInput.focus()
              })
            }
          }
        },
        {
          title: () => this.$t('common.driverType'),
          dataIndex: 'driverType',
          key: 'driverType'
        },
        {
          title: () => this.$t('common.protocolCode'),
          dataIndex: 'protocolCode',
          key: 'protocolCode',
          scopedSlots: { customRender: 'protocolCode' }
        },
        {
          title: () => this.$t('common.dtuCode'),
          dataIndex: 'dtuCode',
          key: 'dtuCode',
          scopedSlots: { customRender: 'dtuCode' }
        },
      
        {
          title: () => this.$t('common.updatedAt'),
          dataIndex: 'updatedAt',
          key: 'updatedAt',
          width: '10%',
          scopedSlots: { customRender: 'updatedAt' }
        },
        {
          title: () => this.$t('common.createdAt'),
          dataIndex: 'createdAt',
          key: 'createdAt',
          width: '10%',
          scopedSlots: { customRender: 'createdAt' }
        },
        {
          title: () => this.$t('common.operation'),
          dataIndex: 'operation',
          key: 'operation',
          scopedSlots: {
            customRender: 'operation'
          }
        }
      ],
      queryFields: ['deviceName', 'brand'],
      deviceList: [],
      fetching: false,
      customerList: [],
      stationForm: {
        code: '',
        name: '',
        customerId: undefined,
        content: null,
        company: '',
        remark: null,
        gasElectricRatio: '',
        interval: 150,
        extraProperty: null
      },
      extraProperty: {
        pressure: '',
        flow: '',
        model: ["2"],
        charts: [],
        stations: [],
        devicesList: [],
        unit: 'Nm³'
      },
      total: 0,
      deviceModalVisible: false,
      pressureShow: false,
      flowShow: false,
      customerResultList: [],
      page: 1,
      pressureTableList: [
        {
          deviceCode: '',
          data: '',
          dataList: []
        }
      ],
      flowTableList: [
        {
          deviceCode: '',
          data: '',
          dataList: []
        }
      ],
      dataList: [],

      groupDrawer: {
        deviceList: [],
        visible: true
      },
      selectedPressureList: [],
      selectedFlowList: [],
      pressureStr: '',
      pressure: '',
      flow: '',
      flowStr: '',
      state: "",
      selectedDevices: [],
      selectKey: 0,
      rules: {
        code: [
          {
            required: true,
            message: this.$t('station.esc'),
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('station.esc'),
            trigger: "blur"
          }
        ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec'),
            trigger: "blur"
          }
        ],
      },
      customerName: '',
      stations: [],
      selectedStations: [],
      customerList: [],
      searchingCustomer: false,
      cLoading: false
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  beforeDestroy() {
    this.$store.commit("setStationInfo", null)
  },
  methods: {
    translate() {
      this.rules = {
        code: [
          {
            required: true,
            message: this.$t('station.esc'),
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('station.esc'),
            trigger: "blur"
          }
        ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec'),
            trigger: "blur"
          }
        ],
      }
    },
    async getDevices() {
      const { data } = await getDeviceGroup(this.$store.state.stationInfo.id)
      this.stationForm = {
        id: data.id,
        code: data.code,
        name: data.name,
        content: data.content,
        customerId: data.customerId,
        company: data.company,
        remark: data.remark,
        gasElectricRatio: data.gasElectricRatio,
        interval: data.interval,
        elecVisible: data.elecVisible
      }
      this.extraProperty = data.extraProperty
      this.extraProperty.model = data.extraProperty?.model || []
      this.extraProperty.charts = data.extraProperty?.charts || []
      if (!this.extraProperty.unit) {
        this.extraProperty.unit = 'Nm³'
      }
      this.selectedDevices = JSON.parse(data.extraProperty.deviceCodes) || []
      // this.selectedDevices = data.extraProperty.deviceCodes
      this.deviceList = data.devices
      this.groupDrawer.deviceList = data.devices
      this.selectedStations = data.extraProperty.stations
      this.pressure = data.extraProperty.pressure
      this.flow = data.extraProperty.flow
      console.log(this.groupDrawer.deviceList);
      // this.setTableList()
      // deviceGroupApi.get(this.stationForm.stationCode).then(({ data }) => {
      //   this.total = data.devices.length
      //   this.deviceList = data.devices
      //   this.groupDrawer.deviceList = data.devices
      //   const chart = JSON.parse(data.chart)
      //   this.selectedStations = chart.stations
      //   if (data.deviceCodes) {
      //     this.selectedDevices = JSON.parse(data.deviceCodes)
      //     this.selectKey = this.selectedDevices[0] || this.selectKey
      //   }
      if(this.state === "编辑") {
        this.setTableList()
      }
      // })
    },
    handleUnitChange(v) {
      this.extraProperty.unit = v
      this.$forceUpdate()
    },
    getStations() {
      deviceGroupApi.list(1, 10).then(async ({ data }) => {
        if (data.total > 10) {
          const deviceGroupList = await deviceGroupApi.list(1, data.total)
          this.stations = deviceGroupList.data.records
        } else {
          this.stations = data.records
        }
      })
    },
    setTableList() {
      if (!this.pressure && !this.flow) {
        return
      }
      const pressure = this.pressure.split(' + ')
      if(pressure.length > 0) {
        this.pressureTableList = []
      }
      pressure.forEach((item, index) => {
        const i = item.slice(2, -1).split('.')
        const device = this.groupDrawer.deviceList.find(device => device.code === i[0])
        this.pressureTableList.push({
          deviceCode: i[0],
          data: i[1],
          dataList: []
        })
        this.getDataByDevice(device, index, 'pressure')
      })
      const flow = this.flow.split(' + ')
      if(flow.length > 0) {
        this.flowTableList = []
      }
      flow.forEach((item, index) => {
        const i = item.slice(2, -1).split('.')
        const device = this.groupDrawer.deviceList.find(device => device.code === i[0])
        this.flowTableList.push({
          deviceCode: i[0],
          data: i[1],
          dataList: []
        })
        this.getDataByDevice(device, index, 'flow')
      })
    },
    hideSelectOption (e) {
      if (e.target.tagName === 'LI' || e.target.tagName === 'A' || e.target.tagName === 'INPUT') {
        return undefined
      } else {
        this.pressureShow = false
        this.flowShow = false
      }
    },
    moment,
    customerChange (value) {
      this.stationForm.customerId = value
      this.stationForm.companyName = this.customerList.find(item => item.id === value).companyName
    },
    save () {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          this.extraProperty.stations = this.selectedStations
          this.extraProperty.deviceCodes = JSON.stringify(this.selectedDevices)
          this.stationForm.extraProperty = this.extraProperty
          this.stationForm.extraProperty.chart = {
            model: this.extraProperty.model,
            charts: this.extraProperty.charts
          }
          this.stationForm.extraProperty.chart = JSON.stringify(this.stationForm.extraProperty.chart)
          this.stationForm.devices = this.deviceList.map(item => {
            return {
              id: item.id
            }
          })
          if (this.stationForm.id) {
            try {
              const { message } = await updateDeviceGroup(this.stationForm)
              this.$message.success(message)
              this.$router.back()
            } catch {
            }
          } else {
            try {
              const { message } = await addDeviceGroup(this.stationForm)
              this.$message.success(message)
              this.$router.back()
            } catch {
            }
          }
        }
      })
    },
    closeModal (list) {
      let selectedDevices = []
      if(list) {
        console.log(list);
        this.deviceList = list.map(item => {
          if(item.type === 'LLJ' || item.type === 'DB') {
            selectedDevices.push(item.code)
          }
          return item
        })
      } else {
        selectedDevices = this.selectedDevices
        this.deviceList = this.deviceList
      }
      this.selectedDevices = selectedDevices
      this.deviceModalVisible = false
    },
    addItem (type) {
      if (type === 'pressure') {
        this.pressureTableList.push({
          deviceCode: '',
          data: '',
          dataList: []
        })
      } else if (type === 'flow') {
        this.flowTableList.push({
          deviceCode: '',
          data: '',
          dataList: []
        })
      }
    },
    removeTableItem (type) {
      if (type === 'pressure') {
        this.pressureTableList.pop()
        this.selectedPressureList.pop()
      } else if (type === 'flow') {
        this.flowTableList.pop()
        this.selectedFlowList.pop()
      }
      this.setStr(type)
    },
    setData (type, dataObj, index) {
      console.log(index)
      if (type === 'pressure') {
        this.selectedPressureList[index] = dataObj
        console.log(this.selectedPressureList)
      } else if (type === 'flow') {
        this.selectedFlowList[index] = dataObj
      }
    },
    setStr (type) {
      if (type === 'pressure') {
        this.pressure = ''
        this.pressureTableList.forEach(pressure => {
          this.pressure += '${' + pressure.deviceCode + '.' + pressure.data + '} + '
        })
        this.extraProperty.pressure = this.pressure = this.pressure.slice(0, -3)
      }
      if (type === 'flow') {
        this.flow = ''
        this.flowTableList.forEach(flow => {
          this.flow += '${' + flow.deviceCode + '.' + flow.data + '} + '
        })
        this.extraProperty.flow = this.flow = this.flow.slice(0, -3)
      }
    },
    async getDataByDevice(device, index, type) {
      try {
        const { data } = await getProtocol(device.protocolCode)
        // const { data } = await protocolApi.get(device.driverType, device.protocolCode)
        if (type === 'pressure') {
          this.pressureTableList[index].dataList = data.points.filter(d => d.dataWrite !== 2)
        }
        if (type === 'flow') {
          this.flowTableList[index].dataList = data.points.filter(d => d.dataWrite !== 2)
        }
      } catch {}
    },
    selectCustomer(c) {
      this.stationForm.customerId = c.id
      this.stationForm.company = c.company
      this.customerName = c.company
    },
    async handleSearchCustomer() {
      const value = this.stationForm.company.trim()
      if (!value) {
        return this.$message.warn(this.$t('station.ecn'))
      }
      this.customerList = []
      this.searchingCustomer = true
      this.cLoading = true
      try {
        const { data } = await searchCustomerList(this.page, 20, {
          query: [
            {
              field: 'company',
              value
            }
          ],
          filter: [],
          sort: []
        })
        this.customerList = data.records
        this.page = 1
      } catch(e) {
        console.log(e)
      } finally {
        this.cLoading = false
      }
    },
    async handlePopupScroll(e){
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if(scrollHeight - scrollTop === clientHeight){
        this.page++
        const { data } = await searchCustomerList(this.page, 10, queryParams)
        this.customerResultList = this.customerResultList.concat(data.records)
      }
    },
    handleBlur() {
      this.page = 1
      this.protocolPage = 1
      this.protocolList = []
      this.userList = []
      this.$forceUpdate()
    },
    setCompany(value) {
      const i = this.customerResultList.find(c => c.id === value)
      this.stationForm.company = i.company
      console.log(this.stationForm.company);
    },
    removeDevice(device) {
      const index = this.deviceList.findIndex(d => d.id === device.id)
      this.deviceList.splice(index, 1)
    },
    handleElecVisibleChange(e) {
      this.stationForm.elecVisible = e.target.checked
    }
  }
}
</script>

<style lang="less" scoped>
.row {
  margin-top: 5px;
}
.dataMenu {
  width: 120%;
  position: relative;
  border: 1px solid #ccc;
  margin-top: -5px;
  padding: 0 10px;
}
.dataMenu ul,
.dataMenu ul li {
  padding: 0;
  margin: 0;
}
ul.customer {
  position: absolute;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  z-index: 100;
  background-color: #fff;
  min-height: 30px;
  max-height: 300px;
  overflow: auto;
  list-style: none;
  padding: 3px 0;
  border-radius: 5px;
  box-shadow: 0 0 2px rgba(0, 0, 0, .3);
  li {
    padding: 0 10px;
    margin: 0;
    width: 100%;
    height: 30px;
    line-height: 30px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  li:hover {
    background-color: #e6f7ff;
  }
}
</style>
